(() => {
  const SELECTOR = '[data-product-card-shipping]';

  // Dispatch days, their per-day Istanbul cutoffs and per-product holds live
  // in shipping-promise.js, shared with the product page countdown.
  const getShippingText = (handle) => {
    const { shipsToday, deadlineText } = window.ShippingPromise.resolve({ handle });

    return shipsToday ? 'Bugün kargoda!' : deadlineText;
  };

  const applyTo = (badge, text) => {
    const deliveryText = badge.querySelector('[data-shipping-text]');

    if (deliveryText && deliveryText.textContent !== text) {
      deliveryText.textContent = text;
    }
  };

  // Walk only what was handed to us. A full-document querySelectorAll costs
  // several thousand element visits on a listing page, and the observer below
  // fires for every carousel slide change, app embed and drawer toggle on the
  // page — not just for the ones that actually insert cards.
  const updateShippingTexts = (roots) => {
    // One resolve() per product per walk, not per badge: carousels repeat the
    // same product, and a held one reads differently from its neighbours.
    const texts = new Map();
    const update = (badge) => {
      const handle = badge.dataset.productHandle || '';
      if (!texts.has(handle)) texts.set(handle, getShippingText(handle));
      applyTo(badge, texts.get(handle));
    };

    roots.forEach((root) => {
      if (root.nodeType !== 1 || !root.isConnected) return;
      if (root.matches(SELECTOR)) update(root);
      root.querySelectorAll(SELECTOR).forEach(update);
    });
  };

  const updateAll = () => updateShippingTexts([document.documentElement]);

  const pendingRoots = new Set();
  let updateQueued = false;

  const queueUpdate = (records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) pendingRoots.add(node);
      }
    }

    if (!pendingRoots.size || updateQueued) return;

    updateQueued = true;
    window.requestAnimationFrame(() => {
      updateQueued = false;
      const roots = Array.from(pendingRoots);
      pendingRoots.clear();
      updateShippingTexts(roots);
    });
  };

  const init = () => {
    if (!window.ShippingPromise) {
      // Bail rather than reimplement the rules locally — a second copy of them
      // is exactly how the cards and the product page drifted apart before.
      // The badge keeps whatever the Liquid snippet rendered.
      console.warn('product-card-shipping: shipping-promise.js did not load.');
      return;
    }

    updateAll();

    // Crosses the dispatch cutoff. Cheap: a resolve() per product plus one walk.
    window.setInterval(updateAll, 60000);

    // The free-shipping / delivery alternation used to live here as a 3s
    // setInterval toggling a class on every badge on the page — ~80 CSS
    // transitions restarted every 3 seconds, forever, including while the tab
    // was in the background. It is now a pure CSS animation on
    // .product-card__shipping-badge--rotating (theme.css), which the compositor
    // runs without touching the main thread.

    new MutationObserver(queueUpdate).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
